import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';

import { ButtonModule, DialogRef, IconModule } from '@hglobal/fin-ui';
import { TranslateModule } from '@ngx-translate/core';

import { LogoComponent } from '@iw/common';
import { AuthStore } from '@iw/core/auth-store';
import { ClipboardService } from '@iw/core/services';
import { RouterStore } from '@iw/store';

@Component({
  imports: [TranslateModule, ButtonModule, IconModule, LogoComponent],
  selector: 'iw-tfa-codes',
  templateUrl: './tfa-codes.component.html',
  styleUrls: ['./tfa-codes.component.scss', '../signin-dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TfaCodesComponent {
  readonly #store = inject(AuthStore);
  readonly #routerStore = inject(RouterStore);
  readonly #clipboard = inject(ClipboardService);
  readonly #dialogRef = inject(DialogRef);

  codes = this.#store.recoveryCodes;

  readonly column1 = computed(() => {
    const c = this.codes();
    return c.slice(0, Math.ceil(c.length / 2));
  });

  readonly column2 = computed(() => {
    const c = this.codes();
    return c.slice(Math.ceil(c.length / 2));
  });

  ok(): void {
    this.#routerStore.navigateByUrl('/');
    this.#dialogRef.close();
  }

  copy(codes: string[]): void {
    this.#clipboard.copy(
      'iiiWallet Recovery codes: \n\n' + codes.join('\n'),
      'signin.tfaCodes.codesCopied',
    );
  }
}
